const getLocationValidations = (menu, orderDetails, selectedLocation) => {
  const fulfillmentTypes = {
    'take-out': 'Takeout',
    curbside: 'Curbside',
    'drive-through': 'DriveThrough',
    delivery: 'Delivery',
    shipping: 'Shipping',
    'dine-in': 'DineIn'
  };

  const orderType = orderDetails.fulfillmentType === 'pick-up' ? orderDetails.pickupType : orderDetails.fulfillmentType;

  const parsedResult = selectedLocation.validations.reduce((reducerObj, validation) => {
    /**
      * For a selected location's validation rules with multiples of the same "fulfillmentType", the validation's "menuType" will be the discerning
      * factor in determining what the selected location's validation should be set.
      *
      * Parse the validation for a matched "menuType" with the order's menu type (ie. order.menuType),
      * in addition to parsing the list of validations and "caching" any validation (without a specified "menuType") that matches the order's
      * "fulfillmentType".
    */

    const isFulfillmentTypeMatch = validation.fulfillmentType === fulfillmentTypes[orderType];
    const isMenuTypeMatch = validation.menuType === menu.menuType;
    const hasOrderAmountLimits = validation.orderMinimumAmount != null || validation.orderMaximumAmount != null;

    /** Instead of checking order.menuType check menu.menuType */
    if (isFulfillmentTypeMatch && isMenuTypeMatch) {
      reducerObj.matchedMenuTypeValidation = validation;
    }
    else if (isFulfillmentTypeMatch && !validation.menuType) {
      reducerObj.matchedFulfillmentTypeValidation = validation;
    }

    /*
      For menuType-specific menus (e.g. Catering, Kiosk) merchants commonly define order min/max
      on a single rule and expect it to apply across every fulfillment method on that menu. Capture
      the first such rule as a menu-level fallback used in the precedence below.
    */
    if (validation.menuType && isMenuTypeMatch && hasOrderAmountLimits && !reducerObj.matchedMenuTypeOnlyValidation) {
      reducerObj.matchedMenuTypeOnlyValidation = validation;
    }

    return reducerObj;
  }, { matchedMenuTypeValidation: null, matchedMenuTypeOnlyValidation: null, matchedFulfillmentTypeValidation: null });

  /*
   * Precedence:
   * 1. Exact (menuType + fulfillmentType) match WITH order amount limits — most specific.
   * 2. Any rule on the same menuType WITH order amount limits — menu-level fallback.
   * 3. Exact (menuType + fulfillmentType) match without limits — confirms availability.
   * 4. Fulfillment-only match (no menuType).
  */
  const exactMatch = parsedResult.matchedMenuTypeValidation;
  const exactMatchHasLimits = exactMatch
    && (exactMatch.orderMinimumAmount != null || exactMatch.orderMaximumAmount != null);

  if (exactMatchHasLimits) return exactMatch;

  return parsedResult.matchedMenuTypeOnlyValidation
    || exactMatch
    || parsedResult.matchedFulfillmentTypeValidation;
};

export default getLocationValidations;

/** NOTES:
 * Order Ahead orders are preconfigured with fulfillmentType == "pick-up" (see order/wrapper-page.vue and orders/normalizeOrderDetails);
 * fulfillmentType type of "pick-up" is a "catch-all" for all order ahead pickup types ('Take-out', 'Curbside', 'Drive-Through').
*/

